import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Set SEO meta tags
document.title = 'Domisafe – Simple Software for Organised Daily Work';
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute('content', 'Domisafe helps businesses manage tasks, communication and customer information in one cloud-based platform.');
} else {
  const meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = 'Domisafe helps businesses manage tasks, communication and customer information in one cloud-based platform.';
  document.head.appendChild(meta);
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-122">
    <App data-id="element-123" />
  </React.StrictMode>);